import { TextField, Tooltip, withStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { useLayoutEffect, useRef, useState } from 'react';

import styles from './styles/textFieldRow';

const TextFieldRow = ({
  label,
  value,
  classes,
  disabled = false,
  smallFont = false
}) => {
  const inputRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const input = inputRef.current;
    if (input) {
      setIsOverflowing(input.scrollWidth > input.clientWidth);
    }
  }, [value]);

  return (
    <div className={classes.root}>
      <div className={classes.label}>{label}</div>
      <Tooltip title={isOverflowing ? value || '' : ''}>
        <TextField
          variant="outlined"
          margin="dense"
          value={value}
          className={classes.fieldValue}
          disabled={disabled}
          classes={{
            root: classes.textfieldRoot
          }}
          inputProps={{
            ref: inputRef,
            className: clsx(
              classes.inputEllipsis,
              smallFont && classes.inputSmallFont
            )
          }}
        />
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(TextFieldRow);
